import { type Area } from './ResortDistrict';

export const isAreaExclusiveCollection = (area: Area) => {
  return (
    area.comfort?.id === 'area_comfort_level_5_tridents' ||
    area.comfort?.id === 'area_comfort_level_villas_and_chalets'
  );
};

export const getResortDistrictQuery = (resortId: string) => `query {
  pickYourRoom {
    resortSettings(resortId : "${resortId}") {
      initialViewport { ...viewPort }
      targetViewport { ...viewPort }
      maxBounds { minLon maxLon minLat maxLat minZoom maxZoom }
    }
  }
  resortAreas(resortId: "${resortId}") {
    areas {
      associatedAccess {
        id
        label
      }
      description
      id
      images
      label
      comfort {
        id
      }
      shortDescription
    }
    geoData(resortId: "${resortId}") {
      areas {
        id
        label
        pickable
      }
      areas_geo_json {
        features {
          geometry {
            coordinates
            type
          }
          properties {
            area_id: id
          }
          type
        }
        type
      }
      areas_center_geo_json {
        features {
          geometry {
            coordinates
            type
          }
          properties {
            area_id: id
          }
          type
        }
        type
      }
    }
  }
}
    
fragment viewPort on ViewportType {
  latitude
  longitude
  zoom
  bearing
  pitch
}`;
